// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 90) return "static/chunks/90-ebf7a587731cd564.js";
	if (chunkId === 642) return "static/chunks/642-7a2b69bf43bf8fee.js";
	if (chunkId === 347) return "static/chunks/347-b060663da8600f7b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"192":"3248d5d0a1539b6d","348":"db6f3cdc453c8bab","402":"87d68805e2d1e6ba","722":"e96c7413000bfc95","728":"0d14c9d1cdea2378"}[chunkId] + ".js";
};